__turbopack_context__.v({
  "avatar": "AboutPage-module__YVL5aG__avatar",
  "container": "AboutPage-module__YVL5aG__container",
  "content": "AboutPage-module__YVL5aG__content",
  "dot": "AboutPage-module__YVL5aG__dot",
  "expCompany": "AboutPage-module__YVL5aG__expCompany",
  "expDesc": "AboutPage-module__YVL5aG__expDesc",
  "expList": "AboutPage-module__YVL5aG__expList",
  "expMeta": "AboutPage-module__YVL5aG__expMeta",
  "expPeriod": "AboutPage-module__YVL5aG__expPeriod",
  "expRole": "AboutPage-module__YVL5aG__expRole",
  "experienceCard": "AboutPage-module__YVL5aG__experienceCard",
  "footer": "AboutPage-module__YVL5aG__footer",
  "footerLink": "AboutPage-module__YVL5aG__footerLink",
  "header": "AboutPage-module__YVL5aG__header",
  "headerActions": "AboutPage-module__YVL5aG__headerActions",
  "headerContent": "AboutPage-module__YVL5aG__headerContent",
  "headerText": "AboutPage-module__YVL5aG__headerText",
  "iconButton": "AboutPage-module__YVL5aG__iconButton",
  "location": "AboutPage-module__YVL5aG__location",
  "name": "AboutPage-module__YVL5aG__name",
  "page": "AboutPage-module__YVL5aG__page",
  "paragraph": "AboutPage-module__YVL5aG__paragraph",
  "pulse": "AboutPage-module__YVL5aG__pulse",
  "role": "AboutPage-module__YVL5aG__role",
  "section": "AboutPage-module__YVL5aG__section",
  "sectionBody": "AboutPage-module__YVL5aG__sectionBody",
  "sectionHeader": "AboutPage-module__YVL5aG__sectionHeader",
  "sectionNumber": "AboutPage-module__YVL5aG__sectionNumber",
  "sectionTitle": "AboutPage-module__YVL5aG__sectionTitle",
  "skillCategory": "AboutPage-module__YVL5aG__skillCategory",
  "skillTag": "AboutPage-module__YVL5aG__skillTag",
  "skillTags": "AboutPage-module__YVL5aG__skillTags",
  "skillTitle": "AboutPage-module__YVL5aG__skillTitle",
  "skillsGrid": "AboutPage-module__YVL5aG__skillsGrid",
  "writingLink": "AboutPage-module__YVL5aG__writingLink",
  "writingLinks": "AboutPage-module__YVL5aG__writingLinks",
});
